import React from 'react';
import styles from './IntegrationsMarquee.module.css';
import { Bot, Github, Target, LayoutDashboard, Database, Smartphone, Slack, MessageSquare } from 'lucide-react';

const INTEGRATIONS = [
  {
    name: 'Google Gemini',
    icon: <Bot size={24} />,
    desc: 'Deep AI Video Analysis'
  },
  {
    name: 'Android Studio',
    icon: <Smartphone size={24} />,
    desc: 'Real-World App Traces'
  },
  {
    name: 'GitHub',
    icon: <Github size={24} />,
    desc: 'Workflow Integration'
  },
  {
    name: 'Jira',
    icon: <Target size={24} />,
    desc: 'Coming Soon: Issue Sync'
  },
  {
    name: 'Slack',
    icon: <Slack size={24} />,
    desc: 'Coming Soon: Webhooks'
  },
  {
    name: 'Linear',
    icon: <MessageSquare size={24} />,
    desc: 'Coming Soon'
  }
];

// Double the array to make the infinite scroll smooth
const SCROLL_ITEMS = [...INTEGRATIONS, ...INTEGRATIONS];

export default function IntegrationsMarquee() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.eyebrow}>
        <div className={styles.line} />
        <span>Seamlessly fits into your modern workflow</span>
        <div className={styles.line} />
      </div>
      
      <div className={styles.marqueeContainer}>
        <div className={styles.marqueeTrack}>
          {SCROLL_ITEMS.map((item, idx) => (
            <div key={idx} className={styles.marqueeItem}>
              <div className={styles.iconBox}>
                {item.icon}
              </div>
              <div className={styles.itemText}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemDesc}>{item.desc}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
